import React from "react";

import { useLaunchBrokenFlow } from "../AppErrorProvider";
import { useRuntimeErrorTracker } from "../hooks/useErrorTracker";
import type { ErrorBoundaryProps } from "./ErrorBoundary";
import RuntimeErrorBoundary from "./RuntimeErrorBoundary";

export const BlockingErrorBoundary = ({
  children,
  fallback,
  name,
  namespace,
}: ErrorBoundaryProps) => {
  const trackRuntimeError = useRuntimeErrorTracker(namespace);
  const launchBrokenFlow = useLaunchBrokenFlow();

  return (
    <RuntimeErrorBoundary
      blockableFlow
      fallback={fallback}
      name={name}
      namespace={namespace}
      onError={launchBrokenFlow}
      trackRuntimeError={trackRuntimeError}
    >
      {children}
    </RuntimeErrorBoundary>
  );
};

export default BlockingErrorBoundary;
